import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import type { CraftTemplateType } from '@core-mkt/craft/craft-template-types';
import { EnvService } from '@core-mkt/services/env/env.service';
import { VerticalService } from '@core-mkt/services/vertical/vertical.service';
import { TemplateSingleComponent } from '@core-mkt/shared/templates/single-template/template-component/template-single.component';
import { Template404Component } from '@core-mkt/shared/templates/template-404/template-component/template-404.component';

@Component({
  selector: 'template-dynamic',
  templateUrl: './template-dynamic.component.html',
  styleUrls: ['./template-dynamic.component.scss'],
  standalone: true,
  imports: [TemplateSingleComponent, Template404Component],
})
export class TemplateDynamicComponent {
  private _templateData;
  private pageEntryType: CraftTemplateType;
  segmentIdOverride: string;

  constructor(private route: ActivatedRoute, private env: EnvService, private vertical: VerticalService) {
    this._templateData = {
      pageData: this.route.snapshot.data?.pageData?.craftData,
      apiData: this.route.snapshot.data?.pageData?.apiData,
    };
    this.pageEntryType = this.templateData?.pageData?.entryData?.typeHandle;
    this.segmentIdOverride = this.vertical.getVerticalInfo().segmentId;
  }

  get templateData() {
    return this._templateData;
  }

  get templateName(): string {
    if (this.pageEntryType === 'visionTemplateEntry') {
      return 'template-single';
    } else {
      return 'template-404';
    }
  }
}
